/* mateli-video-enhance.js — YouTube-like skin for product <video> (gallery + modal).
   No dependency. Enhances any <video> inside product media once, hides native
   controls, overlays center play/pause + spinner + scrub/time/mute/fullscreen.
   Reflects state via the video's own events, so the gallery's autoplay / pause-others
   logic still drives it. Swipes still reach the slider (only real taps toggle). */
(function () {
  'use strict';
  var DEBUG = false; // flip to true to trace load/play events in the console
  var log = function () { if (DEBUG) try { console.log.apply(console, ['[MVP]'].concat([].slice.call(arguments))); } catch (e) {} };
  log('script loaded');
  var ROOTS = '#product_gallery, .product-media-modal, media-gallery, .product__media-list';
  var seen = typeof WeakSet !== 'undefined' ? new WeakSet() : { has: function(){return false;}, add: function(){} };

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    t = Math.floor(t);
    var m = Math.floor(t / 60), s = t % 60;
    return m + ':' + (s < 10 ? '0' + s : s);
  }

  // minimal inline icons
  var I = {
    play:  '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>',
    pause: '<svg viewBox="0 0 24 24"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>',
    von:   '<svg viewBox="0 0 24 24"><path d="M3 10v4h4l5 5V5L7 10H3zm13 2a4 4 0 00-2-3.5v7A4 4 0 0016 12z"/></svg>',
    voff:  '<svg viewBox="0 0 24 24"><path d="M3 10v4h4l5 5V5L7 10H3zm16-2l-2 2-2-2-1.4 1.4L14.6 12l-2 2L14 15.4l2-2 2 2L19.4 14l-2-2 2-2z"/></svg>',
    fson:  '<svg viewBox="0 0 24 24"><path d="M4 4h6v2H6v4H4zm10 0h6v6h-2V6h-4zM4 14h2v4h4v2H4zm14 0h2v6h-6v-2h4z"/></svg>',
    fsoff: '<svg viewBox="0 0 24 24"><path d="M6 8h2V4h4V2H6zm10-4v2h4v2h2V4zM6 16H4v4h6v-2H6zm12 2h-4v2h6v-6h-2z"/></svg>'
  };

  function enhance(video) {
    if (seen.has(video)) return;
    seen.add(video);
    var box = video.parentElement;
    if (!box) return;
    log('enhance()', { src: video.currentSrc || (video.querySelector('source') || {}).src, poster: video.poster, autoplay: video.autoplay, muted: video.muted, preload: video.preload, readyState: video.readyState, networkState: video.networkState, parent: box.tagName });
    video.controls = false;
    video.setAttribute('playsinline', '');
    box.classList.add('mvp');

    // loading/diagnostic tracing — tells us WHY a video won't load (autoplay block, no source, network error)
    ['loadstart', 'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough', 'stalled', 'suspend', 'emptied', 'abort', 'ended', 'ratechange'].forEach(function (ev) {
      video.addEventListener(ev, function () { log(ev, { readyState: video.readyState, networkState: video.networkState, currentSrc: video.currentSrc, t: video.currentTime.toFixed(2) }); });
    });
    video.addEventListener('error', function () { var e = video.error || {}; log('ERROR', { code: e.code, message: e.message, networkState: video.networkState, currentSrc: video.currentSrc }); });

    var ui = document.createElement('div');
    ui.className = 'mvp-ui';
    ui.innerHTML =
      '<div class="mvp-spinner" hidden></div>' +
      '<button class="mvp-center" type="button" aria-label="再生 / 一時停止">' +
        '<span class="mvp-play-ico">' + I.play + '</span><span class="mvp-pause-ico">' + I.pause + '</span></button>' +
      '<div class="mvp-bar">' +
        '<button class="mvp-play" type="button" aria-label="再生 / 一時停止">' +
          '<span class="mvp-play-ico">' + I.play + '</span><span class="mvp-pause-ico">' + I.pause + '</span></button>' +
        '<span class="mvp-time">0:00</span>' +
        '<div class="mvp-scrub"><div class="mvp-track"><div class="mvp-buffered"></div><div class="mvp-progress"></div></div>' +
          '<input class="mvp-seek" type="range" min="0" max="1000" value="0" step="1" aria-label="シーク"></div>' +
        '<span class="mvp-dur">0:00</span>' +
        '<button class="mvp-mute" type="button" aria-label="ミュート切替">' +
          '<span class="mvp-vol-on">' + I.von + '</span><span class="mvp-vol-off">' + I.voff + '</span></button>' +
        '<button class="mvp-fs" type="button" aria-label="全画面切替">' +
          '<span class="mvp-fs-on">' + I.fson + '</span><span class="mvp-fs-off">' + I.fsoff + '</span></button>' +
      '</div>';
    box.appendChild(ui);

    var q = function (s) { return ui.querySelector(s); };
    var seek = q('.mvp-seek'), prog = q('.mvp-progress'), buf = q('.mvp-buffered');
    var tCur = q('.mvp-time'), tDur = q('.mvp-dur'), spin = q('.mvp-spinner');
    var hideTimer = null, seeking = false;

    function setPlaying(p) { box.setAttribute('data-playing', p ? 'true' : 'false'); }
    function setMuted(m) { box.setAttribute('data-muted', m ? 'true' : 'false'); }
    function showControls() {
      box.classList.add('mvp-show');
      clearTimeout(hideTimer);
      if (!video.paused) hideTimer = setTimeout(function () { box.classList.remove('mvp-show'); }, 2600);
    }
    function toggle() {
      if (video.paused) {
        video.dataset.mvpUserPaused = 'false';        // user wants it playing -> let gallery autoplay logic be
        video.dataset.mvpStarted = 'true';            // and don't let it reload from scratch
        log('toggle -> play()', { readyState: video.readyState, currentSrc: video.currentSrc });
        var p = video.play();
        if (p && p.catch) p.catch(function (err) { log('play() REJECTED', err && err.name, err && err.message); });
      } else {
        video.dataset.mvpUserPaused = 'true';          // user paused -> gallery must not force-resume
        log('toggle -> pause()'); video.pause();
      }
      showControls();
    }

    // state <- video events
    setPlaying(!video.paused); setMuted(video.muted);
    video.addEventListener('play', function () { log('play (event)'); setPlaying(true); if (video.readyState < 3) spin.hidden = false; showControls(); });
    video.addEventListener('pause', function () { log('pause (event)'); setPlaying(false); spin.hidden = true; box.classList.add('mvp-show'); clearTimeout(hideTimer); });
    video.addEventListener('waiting', function () { log('waiting -> spinner'); spin.hidden = false; });
    video.addEventListener('playing', function () { log('playing -> hide spinner'); spin.hidden = true; });
    video.addEventListener('canplay', function () { spin.hidden = true; });
    video.addEventListener('volumechange', function () { setMuted(video.muted); });
    video.addEventListener('timeupdate', function () {
      if (seeking) return;
      var d = video.duration || 0;
      if (d) { seek.value = String(Math.round(video.currentTime / d * 1000)); prog.style.width = (video.currentTime / d * 100) + '%'; }
      tCur.textContent = fmt(video.currentTime); tDur.textContent = fmt(d);
    });
    video.addEventListener('progress', function () {
      try { if (video.buffered.length) buf.style.width = (video.buffered.end(video.buffered.length - 1) / (video.duration || 1) * 100) + '%'; } catch (e) {}
    });

    // controls
    q('.mvp-center').addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    q('.mvp-play').addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    q('.mvp-mute').addEventListener('click', function (e) { e.stopPropagation(); video.muted = !video.muted; showControls(); });
    q('.mvp-fs').addEventListener('click', function (e) {
      e.stopPropagation();
      var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      if (fsEl) { (document.exitFullscreen || document.webkitExitFullscreen).call(document); }
      else { (box.requestFullscreen || box.webkitRequestFullscreen || video.webkitEnterFullscreen || function(){}).call(box.requestFullscreen ? box : video); }
    });
    function onFs() {
      var on = (document.fullscreenElement || document.webkitFullscreenElement) === box;
      box.setAttribute('data-fs', on ? 'true' : 'false');
    }
    document.addEventListener('fullscreenchange', onFs);
    document.addEventListener('webkitfullscreenchange', onFs);

    // scrubbing — stop the slider from swiping while dragging
    ['pointerdown', 'touchstart', 'mousedown'].forEach(function (ev) {
      seek.addEventListener(ev, function (e) { e.stopPropagation(); seeking = true; }, { passive: true });
    });
    seek.addEventListener('input', function () {
      var d = video.duration || 0; prog.style.width = (seek.value / 10) + '%';
      if (d) tCur.textContent = fmt(seek.value / 1000 * d);
    });
    function endSeek() { if (!seeking) return; var d = video.duration || 0; if (d) video.currentTime = seek.value / 1000 * d; seeking = false; }
    ['pointerup', 'touchend', 'mouseup', 'change'].forEach(function (ev) { seek.addEventListener(ev, endSeek); });

    // tap on the video surface = toggle (only a real tap, so swipes still change slides)
    var dx = 0, dy = 0, sx = 0, sy = 0, moved = false;
    ui.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; moved = false; }, { passive: true });
    ui.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10) moved = true; }, { passive: true });
    ui.addEventListener('click', function (e) {
      if (e.target.closest('.mvp-bar') || e.target.closest('.mvp-center')) { log('tap on control (ignored by bg handler)'); return; }
      if (moved) { log('tap ignored (swipe)'); return; }
      log('tap on video surface -> toggle', { paused: video.paused });
      toggle();
    });

    if (video.paused) box.classList.add('mvp-show');
  }

  function scan(root) {
    var n = 0;
    (root || document).querySelectorAll('video').forEach(function (v) { if (v.closest(ROOTS)) { enhance(v); n++; } });
    if (n) log('scan enhanced', n, 'video(s)');
  }
  function start() {
    log('start(): initial scan');
    scan(document);
    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'VIDEO' && n.closest(ROOTS)) { log('observer: <video> added'); enhance(n); }
          else if (n.querySelectorAll) scan(n);
        });
      });
    });
    document.querySelectorAll(ROOTS).forEach(function (r) { mo.observe(r, { childList: true, subtree: true }); });
    // modal is injected/populated late — also watch body shallowly for it
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') start();
    else document.addEventListener('DOMContentLoaded', start);
  }

  // ponytail: export the one pure helper so a Node self-check can verify it
  if (typeof module !== 'undefined' && module.exports) module.exports = { fmt: fmt };
})();
